import styled from "@emotion/styled";
import igv from "igv";
import { useEffect, useRef } from "react";

const Container = styled.div`
    .igv-container {
        padding-top: 0px;
    }
`;

export default function IGVBrowser(props) {
    const ref = useRef();

    useEffect(() => {
        const options = {
            reference: {
                id: "IRGSP-1.0",
                name: "Oryza_sativa Japonica IRGSP-1.0",
                fastaURL: `${process.env.REACT_APP_BASE_IGV}/Oryza_sativa.IRGSP-1.0.dna_sm.toplevel.fa`,
                indexURL: `${process.env.REACT_APP_BASE_IGV}/Oryza_sativa.IRGSP-1.0.dna_sm.toplevel.fa.fai`,
                cytobandURL: `${process.env.REACT_APP_BASE_IGV}/Oryza_sativa.IRGSP-1.0.51.karyotype.txt`,
            },
            locus: `${props.chromosome}:${props.position}`,
            tracks: [
                {
                    name: "Refseq Genes",
                    type: "annotation",
                    format: "gff3",
                    sourceType: "file",
                    url: `${process.env.REACT_APP_BASE_IGV}/Oryza_sativa.IRGSP-1.0.51.chr.order.gff3.gz`,
                    indexURL: `${process.env.REACT_APP_BASE_IGV}/Oryza_sativa.IRGSP-1.0.51.chr.order.gff3.gz.tbi`,
                    displayMode: "EXPANDED",
                    order: 1000000,
                },
                {
                    name: "SNV",
                    type: "variant",
                    format: "vcf",
                    url: `${process.env.REACT_APP_BASE_IGV}/oryza_sativa_incl_consequences.vcf.gz`,
                    indexURL: `${process.env.REACT_APP_BASE_IGV}/oryza_sativa_incl_consequences.vcf.gz.tbi`,
                },
                {
                    name: "Structural Variant",
                    type: "variant",
                    format: "vcf",
                    url: `${process.env.REACT_APP_BASE_IGV}/oryza_sativa_structural_variations.vcf.gz`,
                    indexURL: `${process.env.REACT_APP_BASE_IGV}/oryza_sativa_structural_variations.vcf.gz.tbi`,
                },
            ],
        };

        igv.createBrowser(ref.current, options).then(function (browser) {
            console.log("Created IGV browser");
        });

        return () => igv.removeAllBrowsers();
    }, [props.position, props.chromosome]);

    return (
        <Container>
            <div className="p-1 border rounded" style={{ minHeight: "50vh" }}>
                <div ref={ref}></div>
            </div>
        </Container>
    );
}
